import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EmailVerificationService } from '../services/email-verification.service';
import { environment } from '../../../environments/environment';

/**
 * Used to automatically hide email verification banner when Account service API results with success
 */
@Injectable()
export class EmailVerificationInterceptor implements HttpInterceptor {
  constructor(private readonly emailVerificationService: EmailVerificationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        // Only check on successful responses from account service
        if (event instanceof HttpResponse &&
            req.url.startsWith(environment.asamm.accountServiceUrl) &&
            event.status >= 200 &&
            event.status < 300) {
          this.emailVerificationService.clearVerificationRequired();
        }
      })
    );
  }
}
